export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12047.d66ff43f.jpg";